import { useEffect, useState } from 'react';
import { backendHost } from '../../../providers/apis/blogApi';

export function getListingMediaSrc(mediaPath) {
  if (!mediaPath) return '';
  if (typeof mediaPath === 'string' && mediaPath.startsWith('http')) return mediaPath;
  return `${backendHost}${mediaPath}`;
}

function getContentLabel(postType) {
  const type = String(postType || '').toLowerCase();
  if (type === 'events') return 'Event';
  if (type.includes('podcast')) return 'Podcast';
  if (type === 'news') return 'News';
  if (type.includes('blog')) return 'Blog';
  return 'Article';
}

export function ListingCardImage({
  mediaPath,
  title,
  postType,
  containerClassName = 'w-full aspect-[300/200] rounded-2xl',
  imageClassName = 'w-full aspect-[300/200] rounded-2xl object-cover',
  alt = '',
  fallbackTitleClassName = 'line-clamp-3 text-lg font-medium leading-snug text-[#021744]',
  fallbackText = 'Image unavailable',
  showFallbackLabel = true,
  showFallbackTitle = true,
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const src = getListingMediaSrc(mediaPath);
  const showFallback = !src || imageFailed;
  const resolvedFallbackText = showFallbackLabel
    ? fallbackText
    : `${getContentLabel(postType)} image unavailable`;

  useEffect(() => {
    setImageFailed(false);
  }, [mediaPath]);

  if (showFallback) {
    return (
      <div
        className={`${containerClassName} flex flex-col items-start justify-center gap-3 bg-gradient-to-br from-[#E8F7F5] to-[#D4EEF0] px-6 text-left`}
        aria-label={title ? `${getContentLabel(postType)}: ${title}` : 'Image unavailable'}
      >
        {showFallbackLabel && (
          <span className="text-xs font-semibold uppercase tracking-wider text-[#0099B0]">
            {getContentLabel(postType)}
          </span>
        )}
        <p className={fallbackTitleClassName}>
          {showFallbackTitle
            ? title?.trim() || resolvedFallbackText
            : resolvedFallbackText}
        </p>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || title || ''}
      className={imageClassName}
      crossOrigin="anonymous"
      onError={() => setImageFailed(true)}
    />
  );
}
